type PendingLivenessApprovalListener = () => void;

const PENDING_LIVENESS_APPROVED_AT_STORAGE_KEY = 'auth_pending_liveness_approved_at';
const pendingLivenessApprovalListeners = new Set<PendingLivenessApprovalListener>();

const getLocalStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
};

export const getPendingLivenessApprovedAt = () => {
  const storedValue = getLocalStorage()?.getItem(PENDING_LIVENESS_APPROVED_AT_STORAGE_KEY);

  if (!storedValue) {
    return null;
  }

  const approvedAt = Number(storedValue);

  return Number.isFinite(approvedAt) ? approvedAt : null;
};

export const clearPendingLivenessApprovedAt = () => {
  getLocalStorage()?.removeItem(PENDING_LIVENESS_APPROVED_AT_STORAGE_KEY);
};

export const subscribePendingLivenessApproval = (listener: PendingLivenessApprovalListener) => {
  pendingLivenessApprovalListeners.add(listener);

  return () => {
    pendingLivenessApprovalListeners.delete(listener);
  };
};

export const notifyPendingLivenessApproved = () => {
  try {
    getLocalStorage()?.setItem(PENDING_LIVENESS_APPROVED_AT_STORAGE_KEY, String(Date.now()));
  } catch (storageError) {
    console.warn('[pending-liveness] Failed to store approval timestamp.', storageError);
  }

  pendingLivenessApprovalListeners.forEach((listener) => listener());
};
